import { useState, useCallback } from "react";
import { Form, Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEyeSlash, faCopy } from "@fortawesome/free-solid-svg-icons";
import { useClipboardCopy } from "../../hooks/useClipboard";
import styles from "./styles.module.scss";

export function Token({ data, onChange, checkEmpty = true }) {
  const [edit, setEdit] = useState(false);
  const { copy } = useClipboardCopy();

  const copyToken = useCallback(() => {
    copy(data);
  }, [copy, data]);

  return !data || edit ? (
    <div className={styles.editToken}>
      <Form.Control
        type="text"
        placeholder="Enter API Token"
        className={styles.token}
        isInvalid={checkEmpty && !data}
        value={data ?? ""}
        onChange={(e) => onChange(e.target.value)}
      />
      <Button variant="outline-light" size="sm" onClick={copyToken}>
        <FontAwesomeIcon icon={faCopy} />
      </Button>
      <Button variant="outline-dark" size="sm" onClick={() => setEdit(false)}>
        <FontAwesomeIcon icon={faEyeSlash} />
      </Button>
    </div>
  ) : (
    <div className={styles.tokenHidden} onDoubleClick={() => setEdit(true)}>
      {"*".repeat(80)}
    </div>
  );
}

export function Input({
  data,
  onChange,
  onEdit,
  color,
  placeholder,
  maxWidth,
  className,
  checkEmpty = true,
}) {
  const [value, setValue] = useState(data ?? "");
  const [edit, setEdit] = useState(!data ? true : false);

  const setOut = useCallback(() => {
    if (value) {
      onChange(value);
      setEdit(false);
      onEdit?.(false);
    }
  }, [onChange, onEdit, value]);

  return (
    <div className={styles.inputBox}>
      {edit ? (
        <>
          <Form.Control
            type="text"
            placeholder={placeholder ?? "Insert Id Field"}
            className={`${styles.input} ${className ?? ""}`}
            isInvalid={checkEmpty && !value}
            value={value}
            onChange={(e) => setValue(e.target.value)}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
            }}
            style={{ color, maxWidth }}
          />
          <Button className={styles.btn} variant="outline-secondary" size="sm" onClick={setOut}>
            OK
          </Button>
          {value && (
            <Button
              className={styles.btn}
              variant="outline-dark"
              size="sm"
              onClick={() => {
                setEdit(false);
                onEdit?.(false);
              }}
            >
              Cancel
            </Button>
          )}
        </>
      ) : (
        <div
          className={styles.valore}
          onDoubleClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            setEdit(true);
            onEdit?.(true);
          }}
          style={{ color, maxWidth }}
        >
          {value}
        </div>
      )}
    </div>
  );
}
